import { Timeouts } from '../framework/Timeouts';
function makeFader(address, numSubAddressesX, numSubAddressesY = 1) {
    return {
        address,
        hasNegativeInfinity: true,
        max: 1000,
        min: -13800,
        numSubAddressesX,
        numSubAddressesY,
        precision: 2,
        round: 5,
        scale: 100,
        type: 'number',
    };
}
function makeMute(address, numSubAddressesX, numSubAddressesY = 1) {
    return {
        address,
        defaultValue: true,
        numSubAddressesX,
        numSubAddressesY,
        type: 'boolean',
    };
}
export class YamahaAdecia {
    constructor(socket) {
        this.socket = socket;
        this.firmwareVersion = '2.0.0';
        this.params = [];
        this.serialNumber = 'S7A001001';
        this.sipChannels = [];
        this.timeouts = new Timeouts();
        this.valueType = 'normalized';
        this.asyncHandlers = [
            {
                regExp: /^devinfo\s+serialno/i,
                callback: (match) => {
                    this.socket.send(`OK devinfo serialno "${this.serialNumber}"`);
                },
            },
            {
                regExp: /^devinfo\s+version/i,
                callback: (match) => {
                    this.socket.send(`OK devinfo version "V${this.firmwareVersion}"`);
                },
            },
            {
                regExp: /^devstatus\s+runmode/i,
                callback: (match) => {
                    this.socket.send(`OK devstatus runmode "normal"`);
                },
            },
            {
                regExp: /^event\s+rm:callaction\s+"dial=(.+):(.+)"/,
                callback: (match) => {
                    const sip = this.sipChannels.find(sip => sip.lineName === match[1]);
                    if (sip === undefined) {
                        this.socket.send(`ERROR event InvalidArgument`);
                        return;
                    }
                    sip.lastNumberDialed = match[2];
                    this.socket.send(`OK event rm:callaction "dial=${sip.lineName}:${sip.lastNumberDialed}"`);
                    sip.timeout.set(() => {
                        sip.callStatus = 'inconference_calling';
                        this.socket.send(`NOTIFY event rm:changedcallstatus "${sip.lineName}=${sip.callStatus}"`);
                        this.socket.send(`NOTIFY event rm:changedcallstatus "${sip.lineName}number=${sip.lastNumberDialed}"`);
                        sip.timeout.set(() => {
                            sip.callStatus = 'inconference_active';
                            this.socket.send(`NOTIFY event rm:changedcallstatus "${sip.lineName}=${sip.callStatus}"`);
                        }, 1000);
                    }, 300);
                },
            },
            {
                regExp: /^event\s+rm:callaction\s+"dtmf=(.+):(.+)"/,
                callback: (match) => {
                    const sip = this.sipChannels.find(sip => sip.lineName === match[1]);
                    if (sip === undefined) {
                        this.socket.send(`ERROR event InvalidArgument`);
                        return;
                    }
                    this.socket.send(`OK event rm:callaction "dtmf=${sip.lineName}:${match[2]}"`);
                },
            },
            {
                regExp: /^event\s+rm:callaction\s+"hangup=(.+)"/,
                callback: (match) => {
                    const sip = this.sipChannels.find(sip => sip.lineName === match[1]);
                    if (sip === undefined) {
                        this.socket.send(`ERROR event InvalidArgument`);
                        return;
                    }
                    sip.timeout.clear();
                    sip.callStatus = 'idle';
                    this.socket.send(`OK event rm:callaction "hangup=${sip.lineName}"`);
                    this.socket.send(`NOTIFY event rm:changedcallstatus "${sip.lineName}number="`);
                    this.socket.send(`NOTIFY event rm:changedcallstatus "${sip.lineName}=${sip.callStatus}"`);
                },
            },
            {
                regExp: /^event\s+rm:getcallstatus/,
                callback: (match) => {
                    var _a, _b;
                    const props = {};
                    for (const sip of this.sipChannels) {
                        const callStatus = (_a = sip.callStatus) !== null && _a !== void 0 ? _a : 'idle';
                        props[sip.lineName] = callStatus;
                        props[`${sip.lineName}number`] =
                            callStatus === 'idle' ? '' : (_b = sip.lastNumberDialed) !== null && _b !== void 0 ? _b : '';
                    }
                    const propsStr = Object.entries(props)
                        .map(e => e.join('='))
                        .join(',');
                    this.socket.send(`OK event rm:getcallstatus "${propsStr}"`);
                },
            },
            {
                regExp: /^event\s+/,
                callback: (match) => {
                    this.socket.send(`ERROR event InvalidArgument`);
                },
            },
            {
                regExp: /^get\s+(\S+)\s+(\d+)\s+(\d+)/,
                callback: (match) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    const param = this.params.find(param => param.address === match[1]);
                    if (param === undefined) {
                        this.socket.send(`ERROR get UnknownAddress`);
                        return;
                    }
                    const x = parseInt(match[2], 10);
                    const y = parseInt(match[3], 10);
                    const numSubAddressesX = (_a = param.numSubAddressesX) !== null && _a !== void 0 ? _a : 1;
                    const numSubAddressesY = (_b = param.numSubAddressesY) !== null && _b !== void 0 ? _b : 1;
                    if (x >= (numSubAddressesX !== null && numSubAddressesX !== void 0 ? numSubAddressesX : 1) || y >= (numSubAddressesY !== null && numSubAddressesY !== void 0 ? numSubAddressesY : 1)) {
                        this.socket.send(`ERROR get InvalidArgument`);
                        return;
                    }
                    const index = y * numSubAddressesY + x;
                    if (param.type === 'boolean') {
                        const value = (_e = (_d = (_c = param.values) === null || _c === void 0 ? void 0 : _c[index]) !== null && _d !== void 0 ? _d : param.defaultValue) !== null && _e !== void 0 ? _e : false;
                        this.socket.send(`OK get ${param.address} ${x} ${y} ${value ? '1' : '0'}`);
                    }
                    else {
                        let value = (_h = (_g = (_f = param.values) === null || _f === void 0 ? void 0 : _f[index]) !== null && _g !== void 0 ? _g : param.defaultValue) !== null && _h !== void 0 ? _h : 0;
                        this.socket.send(`OK get ${param.address} ${x} ${y} ${value}`);
                    }
                },
            },
            {
                regExp: /^identify\s+(\d+)/i,
                callback: (match) => {
                    this.socket.send(`OK identify ${match[1]}`);
                },
            },
            {
                regExp: /^scpmode\s+valuetype\s+(.+)/i,
                callback: (match) => {
                    // Note: the emulator currently only sends notifications in raw format; changing
                    // this setting doesn't do anything.
                    if (match[1] === 'normalized' || match[1] === 'raw') {
                        this.valueType = match[1];
                        this.socket.send(`OK scpmode valuetype ${this.valueType}`);
                    }
                    this.socket.send(`ERROR scpmode InvalidArgument`);
                },
            },
            {
                regExp: /^set\s+(\S+)\s+(\d+)\s+(\d+)\s+(\S+)/,
                callback: (match) => {
                    var _a, _b, _c, _d;
                    const param = this.params.find(param => param.address === match[1]);
                    if (param === undefined) {
                        this.socket.send(`ERROR set UnknownAddress`);
                        return;
                    }
                    const x = parseInt(match[2], 10);
                    const y = parseInt(match[3], 10);
                    const numSubAddressesX = (_a = param.numSubAddressesX) !== null && _a !== void 0 ? _a : 1;
                    const numSubAddressesY = (_b = param.numSubAddressesY) !== null && _b !== void 0 ? _b : 1;
                    if (x >= (numSubAddressesX !== null && numSubAddressesX !== void 0 ? numSubAddressesX : 1) || y >= (numSubAddressesY !== null && numSubAddressesY !== void 0 ? numSubAddressesY : 1)) {
                        this.socket.send(`ERROR set InvalidArgument`);
                        return;
                    }
                    const index = y * numSubAddressesY + x;
                    if (param.type === 'boolean') {
                        if (param.values === undefined)
                            param.values = [];
                        param.values[index] = match[4] !== '0';
                        const numValue = param.values[index] ? '1' : '0';
                        const strValue = param.values[index] ? 'ON' : 'OFF';
                        this.socket.send(`OK set ${param.address} ${x} ${y} ${numValue} "${strValue}"`);
                    }
                    else {
                        let value = parseInt(match[4], 10);
                        if (!param.hasNegativeInfinity && value !== -32768) {
                            if (param.round !== undefined) {
                                value = Math.round(value / param.round) * param.round;
                            }
                            if (value < param.min)
                                value = param.min;
                            if (value > param.max)
                                value = param.max;
                        }
                        if (param.values === undefined)
                            param.values = [];
                        param.values[index] = value;
                        const numValue = value.toString();
                        const strValue = param.hasNegativeInfinity && value === -32768
                            ? '-INFINITY'
                            : param.precision === undefined
                                ? (value * ((_c = param.scale) !== null && _c !== void 0 ? _c : 1)).toString()
                                : (value * ((_d = param.scale) !== null && _d !== void 0 ? _d : 1)).toPrecision(param.precision);
                        this.socket.send(`OK set ${param.address} ${x} ${y} ${numValue} "${strValue}"`);
                    }
                },
            },
            {
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send(`ERROR unknown UnknownCommand`);
                },
            },
        ];
        this.params.push(makeFader('RM:ExtMic_Fader/Ch/Level', 2));
        this.params.push(makeMute('RM:ExtMic_Fader/Ch/On', 2));
        this.params.push(makeFader('RM:FeIn_Fader/Ch/Level', 8));
        this.params.push(makeMute('RM:FeIn_Fader/Ch/On', 8));
        this.params.push(makeFader('RM:FeOut_Fader/Ch/Level', 8));
        this.params.push(makeMute('RM:FeOut_Fader/Ch/On', 8));
        this.params.push(makeMute('RM:MicMute/All', 1));
        this.params.push(makeMute('RM:MicMute/Group', 9));
        this.params.push(makeFader('RM:NeIn_Fader/Ch/Level', 16));
        this.params.push(makeMute('RM:NeIn_Fader/Ch/On', 16));
        this.params.push(makeFader('RM:NeOut_Fader/Ch/Level', 4));
        this.params.push(makeMute('RM:NeOut_Fader/Ch/On', 4));
        this.sipChannels.push({ lineName: 'sip1', timeout: this.timeouts.create() });
        this.sipChannels.push({ lineName: 'sip2', timeout: this.timeouts.create() });
        this.params.push(makeMute('RM:MixBus/Input/Output/On', 11, 10));
        this.params.push(makeFader('RM:MixBus/Input/Output/Level', 11, 10));
    }
    onConfigure(config) {
        this.timeouts.clearAll();
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
}
YamahaAdecia.emulatorType = 'socketEmulator';
YamahaAdecia.key = '-MvixGLx05IB7Em65_Eb';
